import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { DanhMucService, KhachHangTreoThaoService, DatetimeService, UserService } from '../../../../services/index'
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { Message } from 'primeng/components/common/message';

import { environment } from 'environments/environment';
const userLocalName = environment.LOCAL_USER_NAME;

@Component({
  selector: 'app-thongtindcu',
  templateUrl: './thongtindcu.component.html',
  styleUrls: ['./thongtindcu.component.scss'],

  encapsulation: ViewEncapsulation.None
})
export class ThongTinDCUComponent implements OnInit {

  constructor(
    private treothaoService: KhachHangTreoThaoService,
    private user: UserService,
    private confirmationService: ConfirmationService) {
  }

  @Input() meterid: string;
  @Input() action: string;
  @Output() reloadDsKH = new EventEmitter();

  modelDCU: any = [];
  subscription: Subscription;
  isShowProgress = 0;
  msgs: Message[] = [];

  //Danh sách chủng loại
  listChungLoai: any = [];

  //Index công tơ được chọn
  congtoIndex: number = 0;

  imei_moi: string;
  isApproveSua = false;
  taiLaiDS_KH() {
    this.reloadDsKH.emit(null)
  }

  ngOnInit() {
    this.isShowProgress = 1;
    this.laydulieu();
  }

  laydulieu() {

    this.isShowProgress = 1;
    this.msgs = [];
    this.treothaoService.layTT_DCU(this.meterid).subscribe(res => {
      let dataRet = (res);
      if (dataRet.data.length > 0) {
        this.modelDCU = dataRet.data[0];
      }
      else {
      }
      this.isShowProgress = 0
      this.msgs = [];
    });

  }

  luuTT_DCU() {
    this.user.kiemTraQuyen(17).subscribe(
      res => {
        let data = (res).data;
        if (data.length > 0) {
          if (data[0].sua > 0) {
            this.isApproveSua = true;
          }

        }
        else {
          alert("Bạn không có quyền thực hiện chức năng này!");
          return;
        }
      }
    )
    if (this.isApproveSua) {
      let bl = window.confirm("Sửa thông tin DCU này ?");
      if (!bl)
        return

      this.isShowProgress = 1;
      this.msgs = [];
      let curUser = JSON.parse(localStorage.getItem(userLocalName));
      this.treothaoService.suaTT_DCU(
        this.modelDCU.meterid,
        this.modelDCU.imei,
        this.modelDCU.congserver,
        this.modelDCU.loaithietbi == undefined ? '' : this.modelDCU.loaithietbi,
        this.modelDCU.version == undefined ? '' : this.modelDCU.version,
        this.modelDCU.loaisim == undefined ? '' : this.modelDCU.loaisim,
        this.modelDCU.sosim == undefined ? '' : this.modelDCU.sosim,
        this.modelDCU.loaiadapter == undefined ? '' : this.modelDCU.loaiadapter,
        this.modelDCU.loaiangten == undefined ? '' : this.modelDCU.loaiangten,
        this.modelDCU.kinhdo == undefined ? '' : this.modelDCU.kinhdo,
        this.modelDCU.vido == undefined ? '' : this.modelDCU.vido,
        this.modelDCU.csq == undefined ? '' : this.modelDCU.csq,
        this.modelDCU.tenthietbi == undefined ? '' : this.modelDCU.tenthietbi,
        curUser.mataikhoan,
        ''
      ).subscribe(res => {
        let dataRet = (res);
        if (dataRet.result == 'OK' && dataRet.data[0].result == 'OK') {
          this.msgs.push({ severity: 'success', summary: 'Thông báo', detail: 'Sửa DCU thành công' });
        }
        else {
          this.msgs.push({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lưu dữ liệu: ' + dataRet.data[0].result });
        }
        this.isShowProgress = 0;
        this.taiLaiDS_KH();
      });
    } else {
      alert("Bạn không có quyền thực hiện chức năng này!");
    }
  }

  thay_DCU() {
    this.user.kiemTraQuyen(17).subscribe(
      res => {
        let data = (res).data;
        if (data.length > 0) {
          if (data[0].sua > 0) {
            let bl = window.confirm("Thay Modem/DCU ?");
            if (!bl)
              return

            this.isShowProgress = 1;
            this.msgs = [];
            let curUser = JSON.parse(localStorage.getItem(userLocalName));
            this.treothaoService.thay_DCU(
              this.modelDCU.meterid,
              this.modelDCU.socongto,
              this.modelDCU.imei,
              this.imei_moi,
              this.modelDCU.congserver,
              curUser.mataikhoan,
              ''
            ).subscribe(res => {
              let dataRet = (res);
              if (dataRet.result == 'OK' && dataRet.data[0].result == 'OK') {
                this.msgs.push({ severity: 'success', summary: 'Thông báo', detail: 'Thay DCU thành công' });
              }
              else {
                this.msgs.push({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lưu dữ liệu: ' + dataRet.data[0].result });
              }
              this.isShowProgress = 0;
              this.taiLaiDS_KH();
            });
          } else {
            alert("Bạn không có quyền thực hiện chức năng này!");
          }

        }
        else {
          alert("Bạn không có quyền thực hiện chức năng này!");
          return;
        }
      }
    )

  }
}





// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/nhap-thong-tin-kh/khach-hang-treo-thao/thong-tin-dcu/thongtindcu.component.ts